var styleDataHash = "dfd161ff";
const injectCss = () => {
  var css = `.bhGPD [data-hook=popover-content]{position:relative!important}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
};
injectCss();
var emoji_suggestions_modal_default = {
  "emojiSuggestionsModal": "bhGPD"
};
export {
  emoji_suggestions_modal_default as default,
  injectCss
};
//# sourceMappingURL=emoji-suggestions-modal-scss.js.map
